import React from "react";
import Text from "../Text/Text";
import "./Textarea.scss";

const Textarea = ({
    label,
    placeholder,
    value,
    onChange,
    name,
    error = false,
    errorMessage = "Campo requerido",
    disabled = false,
    rows = 4,
    resize = "vertical",
    className = "",
}) => {
    return (
        <div className={`input-field Textarea ${error ? "has-error" : ""} animate__animated animate__fadeInUp ${className}`}>
            {label && (
                <Text size="small" color="var(--gray-dark-500)" className="input-label">
                    {label}
                </Text>
            )}
            <textarea
                className={`input-element textarea-element ${disabled ? "disabled" : ""}`}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                name={name}
                disabled={disabled}
                rows={rows}
                style={{ resize }}
            />
            {error && (
                <Text className="input-error" color="var(--red-600)" size="small">
                    {errorMessage}
                </Text>
            )}
        </div>
    );
};

export default Textarea;
